import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { compose, createStore, applyMiddleware } from 'redux';
import persistState, { transformState, mergePersistedState } from 'redux-localstorage';
import adapter from 'redux-localstorage/lib/adapters/localStorage';
import filter from 'redux-localstorage-filter';
import _ from 'lodash';

import { all } from 'redux-saga/effects';

import createSagaMiddleware from 'redux-saga';
import rootReducer from './reducers';

import { deserialize } from './models';
import Routes from './routes';
import './styles';

import { accountListener } from './services/SFAccountService/saga';
import { opportunityListener } from './services/SFOpportunityService/saga';
import { shippingAddressListener } from './services/SFShippingAddressService/saga';
import { customerInformationsListener } from './services/DataServices/CustomerInformationService/saga';
import { customerDetailsListener } from './services/DataServices/CustomerDetailsService/saga';
import { customerAddressListener } from './services/DataServices/CustomerAddressService/saga';
import { customerQuotationListener } from './services/DataServices/CustomerQuotationService/saga';
import { sfDataListener } from './services/DataServices/SFDataService/saga';
import { driveListener } from './services/DriveService/saga';
import { quotationListener } from './services/SFQuotationService/saga';
import { backOfficeListener } from './services/TillerBackService/saga';

/**
 * I18n
 */
import { I18nextProvider } from 'react-i18next';
import i18n from './I18n';

function* RootListener() {
  yield all([
    accountListener(),
    opportunityListener(),
    shippingAddressListener(),
    customerInformationsListener(),
    customerQuotationListener(),
    customerDetailsListener(),
    customerAddressListener(),
    sfDataListener(),
    driveListener(),
    quotationListener(),
    backOfficeListener(),
  ]);
}

const sagaMiddleware = createSagaMiddleware();

const reducer = compose(
  mergePersistedState((initialState, persistedState) => {
    return _.merge({}, initialState, persistedState);
  }),
)(rootReducer);

const storage = compose(
  filter([
    'customerInformations',
    'customerDetails',
    'customerAddress',
    'customerQuotation',
    'account',
    'shippingAddress',
    'opportunity',
    'quotation',
  ]),
  transformState(
    [
      // serialization (redux to local storage)
      obj => {
        const serialized = {};
        for (var slice in obj) {
          serialized[slice] = obj[slice].serialize();
        }
        return serialized;
      },
      JSON.stringify,
    ],
    [
      // deserialization (local storage to redux)
      JSON.parse,
      raw => {
        const deserialized = {};
        for (var slice in raw) {
          deserialized[slice] = deserialize(raw[slice], raw[slice]['@type']);
        }
        return deserialized;
      },
    ],
  ),
)(adapter(window.localStorage));

const enhancer = compose(
  applyMiddleware(sagaMiddleware),
  persistState(storage, 'tillerStorageKey'),
);

const store = createStore(
  reducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
  enhancer,
);

sagaMiddleware.run(RootListener);

window.addEventListener('beforeunload', ev => {
  ev.preventDefault();
  localStorage.setItem('force', 'true');
});

/* Client Render */
const MOUNT_NODE = document.getElementById('root');

ReactDOM.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <Routes />
      </BrowserRouter>
    </I18nextProvider>
  </Provider>,
  MOUNT_NODE,
);



// WEBPACK FOOTER //
// ./src/index.js